export function scrollingBanner() {
    const multiplicator = 2;
   for (const element of document.querySelectorAll(".scrollingBanner")){
       const textElement = element.querySelector('.contentText');

       window.addEventListener('scroll', function() {
           const positionBanner = element.getBoundingClientRect();
           const diff = window.innerHeight - positionBanner.y;
           let percent = diff/(positionBanner.height/100);

           if(percent < 0){
               percent = 0;
           }
           if(percent > 100 * multiplicator){
               percent = 100 * multiplicator;
           }

           textElement.style.left = (100-percent)*multiplicator + "%";
       });
  }
}